<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title>
          <h3>Ledger Accounts</h3>
          <v-btn color="primary" icon class="elevation-3 ml-3" @click="openLaForm()">
            <v-icon>add</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width: 40%"
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="ledger_acc_headers"
            :items="ledgeraccs"
            class="elevation-0"
            :search="search"
            :loading="loading"
          >
            <template v-slot:item.sn="{ item, index }">
              {{ index + 1 }}
            </template>
            <template v-slot:item.actions="{ item}">
              <v-btn text icon color="blue" @click="editledgeracc(item)">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                text
                icon
                color="pink"
                @click="deleteledgeracc(item, item.index)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <!-- <template v-slot:items="props">
              <td class="text-xs-center">{{ props.index + 1 }}</td>
              <td class="text-xs-center">{{ props.item.name }}</td>
              <td class="text-xs-center">{{ props.item.type }}</td>
              <td class="text-xs-center">
                <v-btn
                  text
                  icon
                  color="blue"
                  @click="editledgeracc(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>

                <v-btn
                  text
                  icon
                  color="pink"
                  @click="deleteledgeracc(props.item, props.item.index)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template> -->
          </v-data-table>

          <!--dialog form to add and edit ledgeracc begins-->
          <m-dialog ref="lafm">
            <template v-slot:modal-title>{{ fm_title }}</template>

            <template v-slot:modal-content>
              <v-form ref="form">
                <v-autocomplete
                  :items="['expense']"
                  label="Type"
                  v-model="ledgeracc_model.type"
                  :rules="valid_rules.required"
                  :auto-select-first="true"
                />

                <v-text-field
                  label="Name"
                  v-model="ledgeracc_model.name"
                  :rules="valid_rules.required"
                />
              </v-form>
            </template>

            <template v-slot:modal-actions>
              <v-btn class="error" text @click.stop="closeLaForm()"
                >Close</v-btn
              >
              <v-btn class="success" text @click="saveledgeracc()">Save</v-btn>
            </template>
          </m-dialog>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import modalDialog from "../shared/modal_dialog";
export default {
  name: "ledger-accounts",
  components: {
    "m-dialog": modalDialog,
  },
  data() {
    return {
      showL: false,
      showLa: false,
      pers: false,
      search: "",
      fm_title: "",
      editedIndex: -1,
      ledgeracc_model: {
        type: "expense",
        name: "",
      },
       ledgeracc_modelcp: {
        type: "expense",
        name: "",
      },
      valid_rules: {
        required: [(v) => !!v || "this field is required"],
      },
      ledger_acc_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn",
        },
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "Type",
          align: "center",
          sortable: false,
          value: "type",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("ledgeraccs/getAll");

    //console.log("ledgeraccsooooo",ledgeraccs)
  },
  computed: {
    ...mapGetters({
      ledgeraccs: "ledgeraccs/LEDGERACCS",
      laerrors: "ledgeraccs/LEDGERACC_ERROR",
      loading: "ledgeraccs/LEDGERACC_LOADING",
    }),
  },
  methods: {
    addledgeracc() {
      this.$store.dispatch("ledgeraccs/add", this.ledgeracc_model);

      if (this.laerrors == null) {
        Object.assign(this.ledgeracc_model,this.ledgeracc_modelcp)
        this.$toast.success("Ledger Account created successfully");
      } else {
        this.$toast.warning(
          "Sorry, an error occured and Ledger Account could not be created."
        );
      }
    },
    deleteledgeracc(ledgeracc, index) {
      if (confirm("Are you sure you want to delete this ledgeracc?")) {
        this.$store.dispatch("ledgeraccs/delete", { ledgeracc, index });
        this.$toast.success("Ledger Account deleted successfully");
      } else {
        this.$toast.error(
          "Sorry, an error occured and Ledger Account could not be deleted."
        );
      }
    },

    editledgeracc(ledgeracc) {
      this.editedIndex = this.ledgeraccs.indexOf(ledgeracc);
      this.ledgeracc_model = Object.assign({}, ledgeracc);

      //alert(this.editedIndex)

      this.openLaForm();
    },
    updateledgeracc(ledgeracc, index) {
      this.$store.dispatch("ledgeraccs/update", { index: index, ledgeracc });

      if (this.laerrors == null) {
        Object.assign(this.ledgeracc_model,this.ledgeracc_modelcp)
        this.editedIndex = -1;
        this.closeLaForm();
        this.$toast.success("Ledger Account updated successfully");
      }
    },
    saveledgeracc() {
      if (!this.$refs.form.validate()) {
        return;
      }

      //decides between editing ledgeracc info or saving ledgeracc info
      if (this.editedIndex > -1) {
        this.updateledgeracc(this.ledgeracc_model, this.editedIndex);
      } else {
        this.addledgeracc();
      }
    },

    openLaForm() {
      var vm = this;
      if (this.editedIndex > -1) {
        this.fm_title = "Edit Ledger Account";
      } else {
        this.fm_title = "New Ledger Account";
      }
      vm.$refs.lafm.IsPersistent();

      vm.$refs.lafm.open();
    },
    closeLaForm() {
      var vm = this;
      Object.assign(this.ledgeracc_model,this.ledgeracc_modelcp)
      vm.$refs.lafm.close();
    },
  },
  watch: {
    showL(val) {
      if (val == false) {
        this.ledgeracc_model = {
          name: "",
          type: "",
        };
      }
    },
  },
};
</script>